import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Content, Icon, Button, ButtonToolbar, Panel } from 'rsuite';
import { omit } from 'lodash/fp';
import * as PERMISSIONS from '../../../../constants/permissions/inventory';
import * as EXPORT_TYPES from '../../../../constants/inventory/InventoryExportTypes';
import { viewAccess, modifyAccess } from '../../../../helpers/permission';
import AccessControl from '../../../../components/AccessControl';
import AccessDenied from '../../../../components/AccessDenied';
import InventoryPageLayout from '../../../../containers/inventory/PageLayout';
import PageHeader from '../../../../components/PageHeader';
import InventorySearchTag from '../../../../containers/inventory/Search/Tag';
import InventoryTagList from '../../../../containers/inventory/TagList';
import InventoryAddTagsModal from '../../../../components/inventory/InventoryAddTagsModal';
import ExportButton from '../../../../containers/inventory/ExportCsvButton';

class InventoryTags extends Component {
  componentDidUpdate({ isSaving: prevIsSaving }) {
    const { isSaving, resetViewState } = this.props;
    if (prevIsSaving && !isSaving) {
      resetViewState();
    }
  }

  componentWillUnmount() {
    const { resetViewState } = this.props;
    resetViewState();
  }

  render() {
    const {
      query,
      onSubmit,
      isFetching,
      isSaving,
      showAddTagsModal,
      onShowAddTagsModal,
      onHideAddTagsModal
    } = this.props;
    return (
      <InventoryPageLayout>
        <AccessControl
          allowWhenAll={[viewAccess(PERMISSIONS.TAG)]}
          fallback={<AccessDenied />}
        >
          <PageHeader title="Tags">
            <Panel bordered>
              <ButtonToolbar style={{ float: 'right' }}>
                <AccessControl allowOnlyFor={viewAccess(PERMISSIONS.TAG)}>
                  {!isFetching && (
                    <ExportButton
                      style={{ marginRight: 5 }}
                      type={EXPORT_TYPES.EXPORT_TAGS}
                      searchQuery={omit(['limit', 'order', 'page'], query)}
                    />
                  )}
                </AccessControl>
                <AccessControl allowOnlyFor={modifyAccess(PERMISSIONS.TAG)}>
                  <Button appearance="primary" onClick={onShowAddTagsModal}>
                    <Icon icon="plus-circle" /> Add more tags
                  </Button>
                </AccessControl>
              </ButtonToolbar>
              <InventorySearchTag placeholder="Type tag and press enter" />
            </Panel>
          </PageHeader>
          <Content>
            <InventoryTagList />
            <InventoryAddTagsModal
              show={showAddTagsModal}
              isSaving={isSaving}
              onSubmit={onSubmit}
              onHide={onHideAddTagsModal}
            />
          </Content>
        </AccessControl>
      </InventoryPageLayout>
    );
  }
}

InventoryTags.propTypes = {
  query: PropTypes.shape({}).isRequired,
  showAddTagsModal: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onShowAddTagsModal: PropTypes.func.isRequired,
  onHideAddTagsModal: PropTypes.func.isRequired,
  resetViewState: PropTypes.func.isRequired
};

export default InventoryTags;
